import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const DOIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="DO" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#C51918"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#F7FCFF"
          fillRule="evenodd"
          d="M7 0h2v5h7v2H9v5H7V7H0V5h7V0Z"
          clipRule="evenodd"
        />
        <Path fill="#4257BF" d="M0 0h7v5H0zM9 7h7v5H9z" />
        <Path
          fill="#309404"
          d="m6.818 5.555.498.048c-.085.89.026 1.265.206 1.265v.5c-.623 0-.815-.65-.704-1.813ZM9.213 5.555l-.497.048c.085.89-.026 1.265-.206 1.265v.5c.622 0 .815-.65.703-1.813Z"
        />
        <Path
          fill="#003994"
          d="M7.364 5.346h.473v.738h-.473zM8.09 6.223h.474v.375c0 .2-.163.363-.364.363h-.11v-.738Z"
        />
        <Path
          fill="#DE2110"
          d="M8.054 5.3h.473v.738h-.473zM7.364 6.223h.472v.738h-.109a.364.364 0 0 1-.363-.363v-.375Z"
        />
        <Path
          fill="#00319C"
          d="m7.167 5.305-.334-.372c.353-.318.721-.483 1.1-.483.38 0 .747.165 1.1.483l-.334.372c-.267-.241-.521-.355-.766-.355-.244 0-.498.114-.766.355Z"
        />
        <Path
          fill="#DE2110"
          d="m7.204 7.797-.335-.372c.353-.318.721-.483 1.1-.483.38 0 .748.165 1.1.483l-.334.372c-.267-.24-.521-.355-.766-.355-.244 0-.498.114-.765.355Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
